import Phaser from "phaser";
import { GameScene } from "./scenes/GameScene";
import { ShipSelectScene } from "./scenes/ShipSelectScene";
import { SplashScene } from "./scenes/SplashScene";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 800,
  height: 600,
  parent: "game-container",
  backgroundColor: "#000011",
  render: {
    antialias: true,
    pixelArt: false,
    mipmapFilter: "LINEAR_MIPMAP_LINEAR",
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [SplashScene, ShipSelectScene, GameScene],
};

new Phaser.Game(config);
